function SetAllRange(id) {
    $('#' + id +' input:checkbox').not(":last").click(function () {
        if ($('#' + id + ' input:checkbox:not(:last):checked').length > 0) {
            $('#' + id + ' input:checkbox:last').prop('checked', false);
        } else {
            $('#' + id + ' input:checkbox:last').prop('checked', true);
        }
    });

    $('#' + id + ' input:checkbox:last').click(function () {
        if ($(this).is(":checked")) {
            $('#' + id +' input:checkbox').not(":last").prop('checked', false);
        } 
    });
}

function SetAllRangeFirst(id) {
    $('#' + id +' input:checkbox').not(":first").click(function () {
        if ($('#' + id + ' input:checkbox:not(:first):checked').length > 0) {
            $('#' + id + ' input:checkbox:first').prop('checked', false);
        } else {
            $('#' + id + ' input:checkbox:first').prop('checked', true);
        }
    });

    $('#' + id + ' input:checkbox:first').click(function () {
        if ($(this).is(":checked")) {
            $('#' + id +' input:checkbox').not(":first").prop('checked', false);
        } 
    });
}
